// extracted by mini-css-extract-plugin
export var pillWrapper = "_pn-0";
export var showOverflow = "_pn-1";